import React, { useState, useEffect } from 'react';
import { Slider, Row, Col, Tag, Segmented } from 'antd';
import GlobalColors from '../assets/colors/GlobalColors';

// Constants
const MIN_MESSAGES = 50;
const MAX_MESSAGES = 5000;
const WHATSAPP_RATE = process.env.REACT_APP_RATE_PER_WHATSAPP_MESSAGE || 0.0363; // Assuming a rate of $0.0168 per message
const SMS_RATE = process.env.REACT_APP_RATE_PER_SMS_MESSAGE || 0.322; //smsportal rate of 0.22 + 15% vat, selling at 0.32 vat included, profit margin 20%
const EMAIL_RATE = process.env.REACT_APP_RATE_PER_EMAIL_MESSAGE || 0.34;
//$17 for 50 email messages => This is based on the fact that MailJet charges 17USD/month for 15000 emails. With the free tier providing 6 000 email credits a month with
//... an imposed limit of 200 mails a day, it makes business and financial sense (from a profit perspective) that users pay for what we're getting free

const MessagesPriceSlider = ({ updateTopUpMessageType, setTopUpAmount, currency = 'ZAR', exchangeRate }) => {
  const rate = currency === 'USD' ? 1 : exchangeRate;
  const [messageType, setMessageType] = useState('SMS');

  const [messages, setMessages] = useState(MIN_MESSAGES);
  const getRate = () => (messageType === 'SMS' ? SMS_RATE : messageType === 'Email' ? currency === 'USD' ? (EMAIL_RATE / rate) / rate : (EMAIL_RATE / rate) : WHATSAPP_RATE);

  // const whatsAppCost = (getRate() * rate).toFixed(2);
  // const smsCost = (getRate() * rate).toFixed(2);

  const getCurrencySymbol = () => (currency === 'ZAR' ? 'R' : '$');

  const [price, setPrice] = useState((messages * getRate() * rate).toFixed(2));

  // Effect to calculate price when messages change---- message bundle values or message type?
  // useEffect(() => {
  //   setPrice((messages * getRate() * rate).toFixed(2));
  //   setTopUpAmount({ price: parseFloat(price), numberOfMessages: messages });
  //   console.log({ messageType, messages, rate, price, function_call: "useEffect", time_stamp: Date.now() });
  // }, [messages, price, rate, setTopUpAmount]);

  window.onload = () => {
    setPrice((messages * getRate() * rate).toFixed(2));
    setTopUpAmount({ price: parseFloat(price), numberOfMessages: messages });
    console.log({ messageType, messages, rate, price, function_call: "window.onload", time_stamp: Date.now() });
    updateTopUpMessageType(messageType);
  }
  
  /*const handleChange = (value) => {
    const newPrice = (value * getRate() * rate).toFixed(2);
    setMessages(value);
    setPrice(newPrice);
    setTopUpAmount({ price: parseFloat(newPrice), numberOfMessages: value });
    console.log({
      messageType, messages, rate, price, function_call: "handleChange", time_stamp: new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(new Date()).replace(/T/, ' ').replace(/Z/, '')});
  };*/

  const handleBundleValueChange = (value) => {
    setMessages(value);
    const newPrice = (value * getRate() * rate).toFixed(2);
    setPrice(newPrice);
    setTopUpAmount({ price: parseFloat(newPrice), numberOfMessages: value });
    console.log({
      messageType, messages, rate, price, function_call: "handleBundleValueChange", time_stamp: new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(new Date()).replace(/T/, ' ').replace(/Z/, '')});
  };

  const handleTypeChange = (value) => {
    setMessageType(value);
    updateTopUpMessageType(value);
  //  handleBundleValueChange(messages);
  };

  useEffect(() => {
    handleBundleValueChange(messages);
  }, [messageType]); 

  return (
    <div style={{ marginBottom: 8 }}>
      <Row gutter={[24, 8]} align='middle' style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Segmented
            options={['SMS', 'WhatsApp', 'Email']}
            value={messageType}
            onChange={handleTypeChange}
          />
        </Col>
      </Row>
      <Slider
        step={50}
        defaultValue={MIN_MESSAGES}
        value={messages}
        min={MIN_MESSAGES}
        max={MAX_MESSAGES}
        onChange={handleBundleValueChange}
      />
      <Row gutter={[24, 8]}>
        <Col span={24}>
          <Row justify='space-between'>
            <Col span={8}>
              <Tag color={GlobalColors.whiteGray} style={{ color: 'black' }}>
                Cost: {getCurrencySymbol()} {(getRate() * rate).toFixed(2)} {messageType === 'SMS' ? "per message" : messageType === 'Email' ? "per email" : "per text"}
              </Tag>
            </Col>
            <Col span={6}>
              <Tag color={GlobalColors.whiteGray} style={{ color: 'black' }}>
                Messages: {messages}
              </Tag>
            </Col>
            <Col span={6}>
              <Tag color={GlobalColors.darkGray} style={{ color: 'white' }}>
                Price: {getCurrencySymbol()} {price}
              </Tag>
            </Col>
          </Row>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  );
};

export default MessagesPriceSlider;
